import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M13 19L2 12L13 5V11.25H22V12.75H13V19Z" fill="black"/>
    </svg>
)
